import React, { useState } from 'react';
import { useEffect } from 'react';
import api from '@/utils/api'
import ModelInlineSearch from '@/components/repairs/ModelnlineSearch';
import { fetchInlineModels } from '@/components/repairs/modules';
import { createSearchModule } from '@/modules/search';
import { API_URL } from '@/constants';
import styled from 'styled-components';
const StyledBox = styled.div`
    .search-input {
        @media (min-width: 768px) {
            min-width: ${props => props.width}px;
            max-width: ${props => props.width}px;
        }
   
`

function WPModelInlineSearch(props) {
    const [module, setModule] = useState()
    useEffect(() => {
        console.log('WP settings', props?.settings)
        const shopName = props?.settings?.shopName
        async function loadData() {
            const shop = await api.get(`${API_URL}/get-shop/?shop=${shopName}`)
            const module = createSearchModule('mragainPluginSearchModelsInline', async () => {
                const models = await fetchInlineModels(shop.id)
                return models;
            })
            setModule(module)
        }

        shopName && loadData()
    }, []);
    const onSelect = (params) => {
        const redirectUrl = props?.settings?.redirect_url
        console.log('inline model select')
        console.log(params)
        if (redirectUrl && params?.id) {
            console.log('redirect...')
            window.location.href = `${redirectUrl}?model=${params.id}`

        } else {
            console.log('reload...')
            window.location.reload()
        }

    }
    if (!module) {
        return null
    }
    return (
        <StyledBox width={props?.settings?.width || '400'}>
            <ModelInlineSearch module={module} onSelect={onSelect} />
        </StyledBox>
    );
}

export { WPModelInlineSearch };


